export default __webpack_public_path__ + "static/media/news5.13beef87.png";